(function () {
  'use strict';

  function initPostalTheme(root) {
    var scope = root || document;
    var items = scope.querySelectorAll('.sp-reveal:not(.sp-reveal--ready)');
    if (!items.length) return;

    items.forEach(function (item) {
      item.classList.add('sp-reveal--ready');
      var delay = parseInt(item.getAttribute('data-delay') || '0', 10);
      if (delay) item.style.transitionDelay = delay + 'ms';
    });

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -35px' });

    items.forEach(function (item) { observer.observe(item); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initPostalTheme(document); });
  } else {
    initPostalTheme(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initPostalTheme(event.target);
  });
}());
